import React from 'react';
import { MapPin, Linkedin, Mail, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050505] text-white py-16 border-t border-white/10" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-101">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-102">
          <div className="col-span-1 md:col-span-2" data-id="element-103">
            <div className="flex items-center gap-2 font-bold text-xl mb-6" data-id="element-104">
              <div className="w-8 h-8 bg-gradient-to-br from-[#ff8a33] to-yellow-500 rounded-lg flex items-center justify-center text-white shadow-md" data-id="element-105">
                <MapPin size={18} data-id="element-106" />
              </div>
              <span data-id="element-107">Christopher Brissette</span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6 leading-relaxed" data-id="element-108">
              Strategic consulting for location-dependent businesses. Turning
              physical sites into scalable revenue assets.
            </p>
            <div className="flex gap-4" data-id="element-109">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#ff8a33] hover:text-white transition-all" data-id="element-110">
                <Linkedin size={18} data-id="element-111" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#ff8a33] hover:text-white transition-all" data-id="element-112">
                <Twitter size={18} data-id="element-113" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-[#ff8a33] hover:text-white transition-all" data-id="element-114">
                <Mail size={18} data-id="element-115" />
              </a>
            </div>
          </div>

          <div data-id="element-116">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-117">Services</h3>
            <ul className="space-y-3 text-gray-400" data-id="element-118">
              <li data-id="element-119">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-120">
                  Location Intelligence
                </a>
              </li>
              <li data-id="element-121">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-122">
                  Expansion Strategy
                </a>
              </li>
              <li data-id="element-123">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-124">
                  Review Systems
                </a>
              </li>
              <li data-id="element-125">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-126">
                  Funnel Infrastructure
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-127">
            <h3 className="font-bold text-lg mb-6 text-white" data-id="element-128">Company</h3>
            <ul className="space-y-3 text-gray-400" data-id="element-129">
              <li data-id="element-130">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-131">
                  About
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-133">
                  Case Studies
                </a>
              </li>
              <li data-id="element-134">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-135">
                  Contact
                </a>
              </li>
              <li data-id="element-136">
                <a href="#" className="hover:text-[#ff8a33] transition-colors" data-id="element-137">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-138">
          <p data-id="element-139">
            &copy; {new Date().getFullYear()} Christopher Brissette. All rights
            reserved.
          </p>
          <p data-id="element-140">Designed for high-growth clinics.</p>
        </div>
      </div>
    </footer>;
}